import { DateTime } from 'luxon'

export const isGivenDateExpired = (date: string, tZone: string) => {
  const expiryDateAndTime = DateTime.fromISO(new Date(date).toISOString(), {
    zone: tZone,
  }).endOf('day')

  const currentDateTime = DateTime.local({ zone: tZone }).endOf('day')
  return expiryDateAndTime < currentDateTime
}
